import React, { Component } from 'react';
import {Toast, List, Flex, Stepper} from 'antd-mobile';
import LinkText from './components/link';
import DatePickerSE from './components/date-picker-view';
import send from '../../utils/send';
import {FARM_ORG, ORG_CODE} from '../../cache';
import df from 'dateformat'
import Table from '../../components/Table';
import EmptyReport from '../../components/EmptyReport';
import F2 from '@antv/f2'

let end = new Date().getTime();
let start = new Date(end - 1000 * 60 *60 *24 * 7);
export default class Report09 extends Component {
  constructor (props) {
    super(props);
    this.state = {
      day: 5,
      startDate: new Date(start),
      endDate: new Date(end),
      params: {},
      tableData: [],
      columns: [
        {
          id: 'group_repeat_name',
          title: '期间',
          align: 'left'
        },
        {
          id: 'count_qty',
          title: '头数',
          align: 'left'
        },
        {
          id: 'percent_rate',
          title: '百分比',
          render (data) {
            return data['percent_rate'] + '%'
          }
        }
      ]
    }
  }
  async componentDidMount() {
    this.setState({
      params: this.getDaysDetect()
    }, () => {
      this.doSearch()
    })
  }
  getDaysDetect = (day = 5) => {
    let params = {};
    for (var i = 1; i < 22; i++) {
      let d1 = (i - 1) * day || 1;
      let d2 = i * day - 1;
      if (d1 > 115) {
        d1 = ''
      }
      if(d2 > 115) {
        d2 = '';
      }
      params['PAR_TEXT_BOX_DAYS_DETECT' + (i)] = (!d1 && !d2) ? '': `${d1}:${d2}`

    }
    return params
  };
  onCancel = () => {
    this.setState({
      showStart: false,
      showEnd: false
    })
  };
  renderChart = (resData) => {
    if (this.chart) {
      this.chart.clear()
    }
    let data = resData.filter(o => o.group_repeat_name !== '汇总');
    const chart = new F2.Chart({
      id: 'container',
      padding: [40, 'auto', 60, 40],
      pixelRatio: window.devicePixelRatio
    });
    chart.axis('count_qty', {
      line: {
        stroke: '#eee'
      }
    });
    // x轴的刻度线和文本旋转
    chart.axis('group_repeat_name', {
      label: {
        rotate: -45 * Math.PI / 180,
        textAlign: 'end',
        textBaseline: 'middle'
      },
      tickLine: {
        length: 4,
        stroke: '#e0e0e0',
        lineWidth: 1
      }
    });
    chart.source(data);
    //y轴左侧文本
    chart.guide().text({
      position: ['0%', '50%'],
      content: '头数',
      style: {
        rotate: -90 * Math.PI / 180,
        fontSize: 10,
        fill: '#333'
      },
      offsetY: 0,
      offsetX: -30
    });
    // x轴下方文本
    chart.guide().text({
      position: ['50%', '100%'],
      content: '期间',
      style: {
        fontSize: 10,
        fill: '#333'
      },
      offsetY: 40,
      offsetX: -20
    });
    data.forEach(item => {
      chart.guide().text({
        position: () => {
          return [item.group_repeat_name, item.count_qty]
        },
        content: item.count_qty || '',
        offsetY: -7
      })
    });

    chart.tooltip({
      showItemMarker: false,
      showTitle: true,
      onShow: function onShow(ev) {
        const items = ev.items;
        items[0].name = null;
        // items[0].name = items[0].title;
        items[0].value = '母猪数量: ' + items[0].value;
      }
    });
    chart.interval()
      .position('group_repeat_name*count_qty')
      .color('#1890FF').size(10);
    this.chart = chart;
    chart.render();
  };
  doSearch = () => {
    const _self = this;
    Toast.loading('加载中', 0);
    const {startDate, endDate, params} = this.state;
    let start = startDate;
    let end = endDate;
    if (startDate > endDate) {
      start = endDate;
      end = startDate;
      this.setState({startDate: start, endDate: end})
    }
    send({
      url: '/api/forward/ifarm/report9',
      method: 'post',
      data: {
        orgCode: ORG_CODE,
        farmOrg: FARM_ORG,
        data: {
          PAR_START_DATE: df(start, 'yyyy-mm-dd'),
          PAR_END_DATE: df(end, 'yyyy-mm-dd'),
          ...params
        }
      }
    }).then(res => {
      Toast.hide();
      let data = res.data;
      this.setState({
        tableData: data
      }, () => {
        data.length > 0 &&  _self.renderChart(data)
      })
    })
  };
  componentWillUnmount() {
    Toast.hide()
  }

  render() {
    const {showStart, showEnd, startDate, endDate, day} = this.state;
    return (
      <React.Fragment>
        <div className="oneH">
          <Flex className={(showStart || showEnd)? 'single-multi-menu-active' : ''}>
            <Flex.Item className={'single-multi-top-nav-bar list-1'}
                       onClick={() => {
                         this.setState({
                           showStart: !showStart,
                           showEnd: false
                         })
                       }}
                       style={{paddingLeft: 15}}
            >
              <LinkText show={showStart}>{'配种组开始时间'}</LinkText>
            </Flex.Item>
            <Flex.Item className={'single-multi-top-nav-bar list-1'}
                       style={{marginLeft: 0}}
                       onClick={() => {
                         this.setState({
                           showStart: false,
                           showEnd: !showEnd
                         })
                       }}
            >
              <LinkText show={showEnd}>{'配种组截止时间'}</LinkText>
            </Flex.Item>
          </Flex>
          <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
            {
              showStart ?<DatePickerSE onCancel={this.onCancel}
                                       onConfirm={(value) => {
                                         this.onCancel();
                                         this.setState({
                                           showStart: false,
                                           startDate: value
                                         }, () => {
                                           this.doSearch()
                                         })
                                       }}
                                       value={startDate}
              /> : null
            }

            {
              showEnd ?<DatePickerSE onCancel={this.onCancel}
                                     onConfirm={(value) => {
                                       this.onCancel();
                                       this.setState({
                                         showEnd: false,
                                         endDate: value
                                       }, () => {
                                         this.doSearch()
                                       })
                                     }}
                                     value={endDate}
              /> : null
            }
          </div>

          <List>
            <List.Item
              extra={<Stepper
                className={'stepper-round'}
                style={{ width: '100%', minWidth: '100px' }}
                showNumber
                min={1}
                max={115}
                defaultValue={day}
                onChange={v => {
                  let obj = this.getDaysDetect(parseInt(v));
                  this.setState({
                    day: parseInt(v),
                    params: {...obj}
                  }, () => {
                    this.doSearch()
                  })
                }}
              />}
            >
              间隔天数
            </List.Item>
          </List>
          {/*表格*/}
          {this.state.tableData.length > 0 ? <div >
              <Table columns={this.state.columns}
                     data={this.state.tableData}
              />
              <List renderHeader={() => ''}>
                <canvas height="300"
                        id="container"
                        width={document.documentElement.clientWidth}
                />
              </List>
            </div> :
            <EmptyReport height={250}
                         width={'100vw'}
            />
          }
          {(showStart || showEnd) ? <div className="mask"/> : null}
        </div>
      </React.Fragment>
    )
  }
}
